// impline-7b3d9e52 — imported invoice lines in the editors.
// Every importer (the GC Septic QuickBooks migration, the server's QuickBooks import and
// opening-balance invoices) writes a line's price as `unitPrice` with no `price` key, and its
// amount already INCLUDES tax (tax lumped into the line, invoice taxAmount 0). Both editors
// compute from `price`, so an Edit save used to set the invoice total to 0.00 (GC Septic
// #13436, 2026-07-24). Mapped once, on load: price = unitPrice, and the line is marked Tax
// Exempt so the editor doesn't add tax on top of a figure that already includes it — an
// untouched imported invoice saves at exactly its stored total. A line that already has a
// `price` (any line an editor has saved) is returned unchanged.
// MIRROR: keep in sync with normalizeImportedLine in
// spatchy-mobile/src/screens/invoices/InvoiceBuilderScreen.js
// impprice-5d2a8c46 — the same rule for display only (the customer portal's invoice page): a line's
// price, or its imported price when it has none. MIRROR: invoiceLinePrice in functions/index.js.
export const importedLinePrice = (item) => Number(item && item.price != null ? item.price : (item && item.unitPrice)) || 0;

export const normalizeImportedLine = (item) => {
    if (!item || item.price != null || item.unitPrice == null) return item;
    return { ...item, price: Number(item.unitPrice) || 0, taxExempt: true };
};
